<template>
    <div id="content">
        <div class="container my-photos" :class="{'my-photos--empty': !customerAlbums.length, '-is-mobile': isMobile}">
            <personal-albums/>
        </div>
        <powered-by v-if="hasPoweredBy"/>
        <vue-headful :title="headTitle($t('my_photos'))"/>
    </div>
</template>

<style lang="scss" scoped>
    #content {
        display: flex;
        flex-direction: column;
    }

    .my-photos--empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-grow: 1;

        &.-is-mobile {
            justify-content: flex-start;
        }
    }
</style>

<style lang="scss">
    .my-photos {

        .hidden-album-box {
            border: 2px dashed #dcdcdc;
        }

        > div {
            margin: 0 !important;
        }
    }
</style>

<script>
  import PoweredBy from '../components/PoweredBy.vue';
  import PersonalAlbums from '../components/account/PersonalAlbums.vue';

  export default {
    components: {
      PersonalAlbums,
      PoweredBy,
    },
  };
</script>